var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: { title: _vm.operationText, backUrl: _vm.backUrl },
      }),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "0 20px 20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            _vm._l(_vm.headTab, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.tit, name: item.name },
              })
            }),
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "formData",
              staticClass: "form-boder-padding",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formData,
                "label-width": "108px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _vm.currentTab >= "1"
                ? _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "1",
                          expression: "currentTab === '1'",
                        },
                      ],
                      attrs: { gutter: 24 },
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "所属应用：",
                                prop: "application",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "from-ipt-width",
                                  attrs: {
                                    disabled: _vm.isDisabled || _vm.isEdit,
                                    size: "small",
                                    placeholder: "请选择",
                                  },
                                  model: {
                                    value: _vm.formData.application,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "application", $$v)
                                    },
                                    expression: "formData.application",
                                  },
                                },
                                _vm._l(_vm.appList, function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注：", prop: "remark" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "460px" },
                                attrs: {
                                  type: "textarea",
                                  rows: 5,
                                  placeholder: "请输入备注",
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formData.remark,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "remark",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.remark",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态：", prop: "status" } },
                            [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                  "active-text": "开启",
                                  "inactive-text": "关闭",
                                  width: 35,
                                  disabled: _vm.isDisabled,
                                },
                                model: {
                                  value: _vm.formData.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "status", $$v)
                                  },
                                  expression: "formData.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.currentTab >= "2"
                ? _c(
                    "el-row",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab === "2",
                          expression: "currentTab === '2'",
                        },
                      ],
                      attrs: { gutter: 24 },
                    },
                    [
                      _c(
                        "el-tabs",
                        {
                          staticClass: "mt14",
                          attrs: { type: "border-card" },
                          on: { "tab-remove": _vm.removePromptItem },
                          model: {
                            value: _vm.promptTab,
                            callback: function ($$v) {
                              _vm.promptTab = $$v
                            },
                            expression: "promptTab",
                          },
                        },
                        _vm._l(_vm.formData.details, function (item, index) {
                          return _c(
                            "el-tab-pane",
                            {
                              key: index,
                              attrs: {
                                label: "提示词" + (index + 1),
                                name: index.toString(),
                                closable: !_vm.isDisabled && index >= 3,
                              },
                            },
                            [
                              _c("prompt-item", {
                                attrs: {
                                  value: item,
                                  index: index,
                                  disabled: _vm.isDisabled,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  Number(_vm.currentTab) > 1
                    ? _c(
                        "el-button",
                        {
                          staticClass: "submission priamry_border",
                          on: { click: _vm.handleSubmitLast },
                        },
                        [_vm._v("上一步")]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: Number(_vm.currentTab) < _vm.headTab.length,
                          expression: "Number(currentTab) < headTab.length",
                        },
                      ],
                      staticClass: "priamry_border",
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitNext("formData")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                  _vm.isEdit
                    ? _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["platform:fortune:ai-prompt:update"],
                              expression:
                                "['platform:fortune:ai-prompt:update']",
                            },
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.isDisabled,
                              expression: "!isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formData")
                            },
                          },
                        },
                        [_vm._v(" 保存")]
                      )
                    : _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["platform:fortune:ai-prompt:save"],
                              expression: "['platform:fortune:ai-prompt:save']",
                            },
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                (_vm.currentTab === "2" ||
                                  _vm.$route.params.id) &&
                                !_vm.isDisabled,
                              expression:
                                "(currentTab === '2' || $route.params.id) && !isDisabled",
                            },
                          ],
                          staticClass: "submission",
                          attrs: { type: "primary", loading: _vm.loadingBtn },
                          on: {
                            click: function ($event) {
                              return _vm.handleSubmit("formData")
                            },
                          },
                        },
                        [_vm._v(" 保存")]
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }